module.exports = __webpack_public_path__ + "static/media/LATTZOTH Image 2.228a83a7.png";